import { render, staticRenderFns } from "./PersonSearch.vue?vue&type=template&id=20d040f4&"
import script from "./PersonSearch.vue?vue&type=script&lang=js&"
export * from "./PersonSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports